// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fitList {
  display: flex;
  flex-direction: column;
  overflow: hidden auto;
  width: 100%;
}
.fitList .list-row {
  display: flex;
  height: fit-content;
  min-height: 35px;
}
.fitList .title {
  background-color: var(--white-color-lightest);
  font-size: var(--text-size-small);
  margin: 0;
  position: sticky;
  top: 0;
  z-index: var(--z-index-local-over-1);
}
.fitList .listtitle {
  align-items: center;
  border-bottom: solid 1px var(--border-weak-color);
  color: var(--font_inactive_color);
  display: flex;
  overflow: hidden;
  padding: 0 8px;
}
.fitList .listtitle .cell-item {
  display: flex;
}
.fitList .listtitle:last-child {
  border-right: none;
}
.fitList .list-group-item.list-group-item-action:hover {
  cursor: pointer;
}
.fitList .listbody {
  font-size: var(--text-size-normal);
}
.fitList .listbody .list-row:hover {
  background-color: var(--hover-color);
  color: var(--font_active_color);
}
.fitList .listbody .listitem {
  display: flex;
  align-items: center;
  border-bottom: solid 1px var(--border-weak-color);
  padding: 16px 8px;
  min-height: 30px;
  white-space: pre-wrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.fitList .listbody .listitem textarea {
  background-color: var(--white-color-lightest);
  border-radius: 3px;
  margin: 6px 0;
}
.fitList .listbody .listitem textarea:hover {
  border: 1px solid var(--border-active-color);
}
.fitList .listbody .listitem:last-child {
  border-right: none;
}
.fitList .listbody .listitem .dropicon {
  color: rgba(255, 255, 255, 0);
}
.fitList .listbody .listitem:hover .dropicon {
  color: var(--font_inactive_color);
}
.fitList .cell-item {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: anywhere;
}
.fitList .cell-item .cell-title-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.fitList .cell-item.sort-cell {
  align-items: center;
  justify-content: space-between;
}
.fitList .cell-item.loading {
  border-radius: 8px;
}
.fitList .sort-button {
  height: 24px;
  width: 24px;
}
.fitList .sorting-button {
  color: var(--font_active_color);
}`, "",{"version":3,"sources":["webpack://./src/components/common/parts/FitList.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,WAAA;AACD;AACC;EACC,aAAA;EACA,mBAAA;EACA,gBAAA;AACF;AACC;EACC,6CAAA;EACA,iCAAA;EACA,SAAA;EACA,gBAAA;EACA,MAAA;EACA,oCAAA;AACF;AACC;EACC,mBAAA;EACA,iDAAA;EAGA,iCAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;AADF;AAGE;EACC,aAAA;AADH;AAGE;EACC,kBAAA;AADH;AAKC;EACC,eAAA;AAHF;AAMC;EACC,kCAAA;AAJF;AAMG;EACC,oCAAA;EACA,+BAAA;AAJJ;AAQE;EACC,aAAA;EACA,mBAAA;EACA,iDAAA;EAEA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;AAPH;AASG;EACC,6CAAA;EACA,kBAAA;EACA,aAAA;AAPJ;AAQI;EACC,4CAAA;AANL;AAUG;EACC,kBAAA;AARJ;AAWG;EACC,6BAAA;AATJ;AAaI;EACC,iCAAA;AAXL;AAgBC;EACC,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,sBAAA;EACA,uBAAA;AAdF;AAeE;EACC,gBAAA;EACA,uBAAA;EACA,mBAAA;AAbH;AAeE;EACC,mBAAA;EACA,8BAAA;AAbH;AAgBE;EAEC,kBAAA;AAfH;AAkBC;EACC,YAAA;EACA,WAAA;AAhBF;AAkBC;EACC,+BAAA;AAhBF","sourcesContent":[".fitList {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\toverflow: hidden auto;\r\n\twidth: 100%;\r\n\r\n\t.list-row {\r\n\t\tdisplay: flex;\r\n\t\theight: fit-content;\r\n\t\tmin-height: 35px;\r\n\t}\r\n\t.title {\r\n\t\tbackground-color: var(--white-color-lightest);\r\n\t\tfont-size: var(--text-size-small);\r\n\t\tmargin: 0;\r\n\t\tposition: sticky;\r\n\t\ttop: 0;\r\n\t\tz-index: var(--z-index-local-over-1); \r\n\t}\r\n\t.listtitle {\r\n\t\talign-items: center;\r\n\t\tborder-bottom: solid 1px var(--border-weak-color);\r\n\t\t// border-top: solid 1px var(--border-weak-color);\r\n\t\t// border-right: solid 1px var(--border-weak-color);\r\n\t\tcolor: var(--font_inactive_color);\r\n\t\tdisplay: flex;\r\n\t\toverflow: hidden;\r\n\t\tpadding: 0 8px;\r\n\r\n\t\t.cell-item {\r\n\t\t\tdisplay: flex;\r\n\t\t}\r\n\t\t&:last-child{\r\n\t\t\tborder-right: none;\r\n\t\t}\r\n\t}\r\n\r\n\t.list-group-item.list-group-item-action:hover {\r\n\t\tcursor: pointer;\r\n\t}\r\n\r\n\t.listbody {\r\n\t\tfont-size: var(--text-size-normal);\r\n\t\t.list-row {\r\n\t\t\t&:hover {\r\n\t\t\t\tbackground-color: var(--hover-color);\r\n\t\t\t\tcolor: var(--font_active_color);\r\n\t\t\t}\r\n\t\t} \r\n\r\n\t\t.listitem {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tborder-bottom: solid 1px var(--border-weak-color);\r\n\t\t\t// border-right: solid 1px var(--border-weak-color);\r\n\t\t\tpadding: 16px 8px;\r\n\t\t\tmin-height: 30px;\r\n\t\t\twhite-space: pre-wrap;\r\n\t\t\toverflow: hidden;\r\n\t\t\ttext-overflow: ellipsis;\r\n\r\n\t\t\ttextarea {\r\n\t\t\t\tbackground-color: var(--white-color-lightest);\r\n\t\t\t\tborder-radius: 3px;\r\n\t\t\t\tmargin: 6px 0;\r\n\t\t\t\t&:hover {\r\n\t\t\t\t\tborder: 1px solid var(--border-active-color);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t&:last-child {\r\n\t\t\t\tborder-right: none;\r\n\t\t\t}\r\n\r\n\t\t\t.dropicon{\r\n\t\t\t\tcolor: rgba(255, 255, 255, 0);\r\n\t\t\t}\t\t\r\n\t\r\n\t\t\t&:hover{\r\n\t\t\t\t.dropicon{\r\n\t\t\t\t\tcolor: var(--font_inactive_color);\r\n\t\t\t\t}\t\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\t.cell-item {\r\n\t\twidth: 100%;\r\n\t\toverflow: hidden;\r\n\t\ttext-overflow: ellipsis;\r\n\t\twhite-space: pre-wrap;\r\n\t\tword-break: break-word;\r\n\t\toverflow-wrap: anywhere;\r\n\t\t.cell-title-text {\r\n\t\t\toverflow: hidden;\r\n\t\t\ttext-overflow: ellipsis;\r\n\t\t\twhite-space: nowrap;\r\n\t\t}\r\n\t\t&.sort-cell {\r\n\t\t\talign-items: center;\r\n\t\t\tjustify-content: space-between;\r\n\t\t}\r\n\r\n\t\t&.loading\r\n\t\t{\r\n\t\t\tborder-radius: 8px;\r\n\t\t}\r\n\t}\r\n\t.sort-button {\r\n\t\theight: 24px;\r\n\t\twidth: 24px;\r\n\t}\r\n\t.sorting-button {\r\n\t\tcolor: var(--font_active_color);\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
